import { render, staticRenderFns } from "./FeedbackForms.vue?vue&type=template&id=0bf402ec"
import script from "./FeedbackForms.vue?vue&type=script&lang=js"
export * from "./FeedbackForms.vue?vue&type=script&lang=js"
import style0 from "./FeedbackForms.vue?vue&type=style&index=0&id=0bf402ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports